import React, { useState } from 'react';
import { Row, Input, Label, Col, Button } from "reactstrap";
import axios from 'axios';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function WhatsApp() {
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const [number, setNumber] = useState('5547337640');
  const [message, setMessage] = useState('');
  const [file, setFile] = useState('');
  const [caption, setCaption] = useState('');
  
  const sendMessage = async () => {
    try {
      await axios.post(`${URL_WHATSAPP}SendMsg`, {
        number: number,
        message: message
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }).then((response)=>{

      if(response.data.message == "Enviado"){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Tu mensaje ha sido enviado",
          showConfirmButton: false,
          timer: 2000,
        });
        // setNumber("")
        // setMessage("")
      }
      })
      .catch((err) => {
        console.log(err);
      });

    } catch (error) {
      console.error('Error al enviar el mensaje:', error);
    }
  };

  const sendFile = async () => {
    try {
      await axios.post(`${URL_WHATSAPP}SendPDF`, {
        number,
        file,
        caption
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }).then((response)=>{

      if(response.data.message == "Enviado"){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Tu mensaje ha sido enviado",
          showConfirmButton: false,
          timer: 2000,
        });
        // setNumber("")
        // setFile("")
      }
      })
      .catch((err) => {
        console.log(err);
      });

    } catch (error) {
      console.error('Error al enviar el mensaje:', error);
    }
  };


  return (
    <>
    <div className="card container col-sm-11">
      <div className="page-header">
        <div>
          <h3 className="page-title">
            <span className="page-title-icon"><i className="fab fa-whatsapp" /></span>
            Enviar Mensaje de WhatsApp
          </h3>
          <p className="page-subtitle">Prueba de envío de mensajes y archivos por WhatsApp</p>
        </div>
      </div>

    <div className="form-section">
      <div className="form-section-header"><i className="fas fa-comment-dots" /><h4 className="form-section-title">Enviar Mensaje de WhatsApp</h4></div>
      <div className="form-section-body">
      <Row>
      <Col md={4}>
        <Label>Número de Teléfono:</Label>
        <Input type="text" value={number} onChange={(e) => setNumber(e.target.value)} />
      </Col>
      <Col md={8}>
        <Label>Mensaje:</Label>
        <Input type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
      </Col>
      </Row>
      <div className="submit-bar">
        <Button color="success" onClick={sendMessage}><i className="fab fa-whatsapp" /> Enviar Mensaje</Button>
      </div>
      </div>
    </div>

    <div className="form-section">
      <div className="form-section-header"><i className="fas fa-paperclip" /><h4 className="form-section-title">Enviar File</h4></div>
      <div className="form-section-body">
      <Row>
      <Col md={4}>
        <Label>Número de Teléfono:</Label>
        <Input type="text" value={number} onChange={(e) => setNumber(e.target.value)} />
      </Col>
      <Col md={4}>
        <Label>Mensaje:</Label>
        <Input type="text" value={file} onChange={(e) => setFile(e.target.value)} />
      </Col>
      <Col md={4}>
        <Label>Caption:</Label>
        <Input type="text" value={caption} onChange={(e) => setCaption(e.target.value)} />
      </Col>
      </Row>
      <div className="submit-bar">
        <Button color="success" onClick={sendFile}><i className="fab fa-whatsapp" /> Enviar File</Button>
      </div>
      </div>
    </div>
    </div>
    </>
  );
}

export default WhatsApp;
